module.exports = {"pagination":{"ListSpeechSynthesisTasks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/polly-2016-06-10.paginators.json
// module id = 461
// module chunks = 1